import { inject, Service } from '@angular/core';
import { HttpService } from '@data-services/http';
import type { Project } from '@models/projects';

@Service()
export class ProjectQueryService {
  private readonly http = inject(HttpService);

  async getProjectsAsync(): Promise<Project[]> {
    return this.http.getObjectAsync<Project[]>('mobile/projects');
  }
}
